import { useState, useEffect } from 'react';
import Scene_01_Rappu from './Scene_01_Rappu.js'
import Scene_01_A_SoitettuOvikelloa from './Scene_01_A_SoitettuOvikelloa.js'
import Scene_01_B_Tunkeuduttu from './Scene_01_B_Tunkeuduttu.js'
import Scene_01_BA_PahoiteltuTunkeutumista from './Scene_01_BA_PahoiteltuTunkeutumista.js'
import Scene_01_BB_EiPahoiteltuTunkeutumista from './Scene_01_BB_EiPahoiteltuTunkeutumista.js'
import Scene_get_out from '../Scene_get_out.js'

import Scene_01_epilogi from './Scene_01_epilogi.js'
import Scene_01_AC_sinuteltu from './Scene_01_AC_sinuteltu'

const Scenepohja_01 = ({ scoreHandler_main, visibilityHandler_main, soundsOn, enimi, ohjNimi }) => {


    //eka scene näkyviin oletuksena
    const [visible_scene_01_rappu, setVisible_scene_01_rappu] = useState(true)
    const [visible_scene_01_A_SoitettuOvikelloa, setVisible_scene_01_A_SoitettuOvikelloa] = useState(false)
    const [visible_scene_01_AC_sinuteltu, setVisible_scene_01_AC_sinuteltu] = useState(false)
    const [visible_scene_01_B_Tunkeuduttu, setVisible_scene_01_B_Tunkeuduttu] = useState(false)
    const [visible_scene_01_BA_PahoiteltuTunkeutumista, setVisible_scene_01_BA_PahoiteltuTunkeutumista] = useState(false)
    const [visible_scene_01_BB_EiPahoiteltuTunkeutumista, setVisible_scene_01_BB_EiPahoiteltuTunkeutumista] = useState(false)
    const [visible_scene_01_get_out, setVisible_scene_01_get_out] = useState(false)
    const [visible_scene_01_epilogi, setVisible_scene_01_epilogi] = useState(false)




    const hideAllScenes = () => {

        setVisible_scene_01_rappu(false)
        setVisible_scene_01_A_SoitettuOvikelloa(false)
        setVisible_scene_01_B_Tunkeuduttu(false)
        setVisible_scene_01_BA_PahoiteltuTunkeutumista(false)
        setVisible_scene_01_BB_EiPahoiteltuTunkeutumista(false)
        setVisible_scene_01_get_out(false)
        setVisible_scene_01_epilogi(false)
        setVisible_scene_01_AC_sinuteltu(false)

    }

    const visibilityHandler = (valinta) => {


        hideAllScenes()

        switch (valinta) {
            case "A_ovikello":
                setVisible_scene_01_A_SoitettuOvikelloa(true)
                break;
            case "A_TervehdysOk":
                setVisible_scene_01_epilogi(true)
                break;

            case "B_EiVarmistutaAsiakkaasta":
                setVisible_scene_01_epilogi(true)
                break;

            case "C_Sinuteltu":
                setVisible_scene_01_AC_sinuteltu(true)
                break;


            case "B_suoraan_sisälle":
                setVisible_scene_01_B_Tunkeuduttu(true)
                break;

            case "A pahoiteltu":
                setVisible_scene_01_BA_PahoiteltuTunkeutumista(true)
                break;
            case "B ei pahoiteltu":
                setVisible_scene_01_BB_EiPahoiteltuTunkeutumista(true)
                break;
            case "scene_01_epilogi":
                setVisible_scene_01_epilogi(true)
                break;
            case "ulos":
                setVisible_scene_01_get_out(true)
                break;

            case "jatka sceneen 02":
                visibilityHandler_main("02")
                break;
            case "play again":
                visibilityHandler_main("play again")

                break;



        }

    }
    // NBNB scenepohjan 01 pistelaskulogiikka tässä komponentissa 

    const timeHandler = (ms) => {

        console.log(`Execution time: ${(Date.now() - ms) / 1000} s`);


    }


    const scoreHandler = (optio, scene) => {
        //Jätetään tämä funktio tähän varalle jos heräisi tarve modata palautetta ennen kuin lähettää sen mainiin.. nyt kuitenkin välitetään mainin scorehandler tämän pohja-tason "läpi"

        scoreHandler_main(optio, scene)

    }



    return (

        <div>

            {
                visible_scene_01_rappu ? <Scene_01_Rappu scoreHandler={scoreHandler_main} visibilityHandler={visibilityHandler} soundsOn={soundsOn} timeHandler={timeHandler} /> : null
            }

            {
                visible_scene_01_A_SoitettuOvikelloa ? <Scene_01_A_SoitettuOvikelloa scoreHandler={scoreHandler_main} visibilityHandler={visibilityHandler} soundsOn={soundsOn} enimi={enimi} onimi={ohjNimi} /> : null
            }

            {
                visible_scene_01_B_Tunkeuduttu ? <Scene_01_B_Tunkeuduttu scoreHandler={scoreHandler_main} visibilityHandler={visibilityHandler} soundsOn={soundsOn} enimi={enimi} onimi={ohjNimi} /> : null
            }

            {
                visible_scene_01_BA_PahoiteltuTunkeutumista ? <Scene_01_BA_PahoiteltuTunkeutumista visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }

            {
                visible_scene_01_BB_EiPahoiteltuTunkeutumista ? <Scene_01_BB_EiPahoiteltuTunkeutumista visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }


            {
                visible_scene_01_AC_sinuteltu ? <Scene_01_AC_sinuteltu visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }
            {
                visible_scene_01_epilogi ? <Scene_01_epilogi visibilityHandler={visibilityHandler} /> : null
            }
            {
                visible_scene_01_get_out ? <Scene_get_out visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }


        </div>



    )


}

export default Scenepohja_01